<app-header></app-header>

<div class="insurance-services-container">
  <h1 class="page-title">Seguros e Serviços</h1>

  <div class="insurance-services-grid">
    <app-dropdown-table
      *ngFor="let group of groups"
      [title]="group.title"
      [subtitle]="group.subtitle"
      [isOpen]="group.isOpen"
      [tableColumns]="tableColumns"
      [tableData]="group.tableData"
      [filterConfig]="filterConfig"
      [serverSidePagination]="group.serverSidePagination"
      [loading]="group.loading"
      [emptyMessage]="group.emptyMessage"
      [errorMessage]="group.errorMessage"
      [viewButtonTracking]="trackingConfig"
      (toggle)="onGroupToggle(group, $event)"
      (pageChange)="onPageChange(group, $event)"
      (pageSizeChange)="onPageSizeChange(group, $event)"
      (viewLeadClick)="onViewLead($event)"
      (searchChange)="onSearchChange(group, $event)"
      (dateRangeChange)="onDateRangeChange(group, $event)"
      (clearAllFilters)="onClearAllFilters(group)"
      (sortChange)="onSortChange(group, $event)"
    ></app-dropdown-table>
  </div>
</div>
